import { createSelector } from "reselect";
import { getCurrentFacility } from "../facility/facilitySelectors";
import type { RootState, SimulatorsEntitiesState } from "StoreTypes";
import type { FacilityNormalized } from "EntityTypes";
import type { SimulatorDto } from "Models";

export const getAllSimulators = (state: RootState): SimulatorDto[] =>
  Object.values(state.entities.simulators);

export const getSimulatorsByFacilityId = createSelector(
  [
    (state: RootState) => state.entities.simulators,
    (_state: RootState, facilityId: string) => facilityId,
  ],
  (
    simulators: SimulatorsEntitiesState,
    facilityId: string,
  ): SimulatorDto[] =>
    Object.values(simulators ?? {}).filter(
      (sim) => String(sim.facilityId) === facilityId,
    ),
);

export const getSimulatorsByCurrentFacility = createSelector(
  getCurrentFacility,
  (state: RootState) => state.entities.simulators,
  (
    currentFacility: FacilityNormalized | undefined,
    simulators: SimulatorsEntitiesState,
  ): SimulatorDto[] => {
    if (!currentFacility) return [];
    return currentFacility.simulators
      .map((simId: string) => simulators[simId])
      .filter((s): s is SimulatorDto => s !== undefined);
  },
);

export const getSimulatorBySimId = (
  state: RootState,
  { simId }: { simId: string },
) =>
  state?.entities?.simulators ? state.entities.simulators[simId] : undefined;

export const getSimulatorsByIdArray = (
  state: RootState,
  ids: string[],
): SimulatorDto[] => {
  if (!state.entities.simulators) return [];
  return Object.values(state.entities.simulators).filter((sim) =>
    ids?.includes(sim.id),
  );
};

export const getScreenshotBySimId = (
  state: RootState,
  { simId }: { simId: string },
) =>
  state?.entities?.screenshots ? state.entities.screenshots[simId] : undefined;
